export const GSC_MAP = {
  2: 'Basic',
  4: 'Intermediate',
  6: 'Advanced',
} as const;
